<template>
  <div class="flex flex-row">
    <h2 class="flex-1 text-left text-xl text-dark-gray">Users</h2>
    <button-main
      class="flex flex-1 cursor-pointer flex-row items-center justify-end text-1md text-yellow-500"
      variant="link"
      @click="openInvitationModal"
    >
      Invite New User
      <img
        class="ml-1"
        src="@/assets/plus-yellow-icon.svg"
        alt="close icon"
      />
    </button-main>
  </div>
  <div>
    <table class="w-full">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Last Login</th>
          <th>Driver</th>
          <th>Onboarding</th>
          <th>Manage Users</th>

          <th>View Rate Confirmations</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, rowIndex) in companyUsers"
          :key="user.id"
          :class="[rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50', 'py-2']"
        >
          <td>
            <span>{{ user.first_name }} {{ user.last_name }}</span>
          </td>
          <td>
            <span> {{ user.email }} </span>
          </td>
          <td>
            <span>
              {{ moment(user.last_sign_in_at).format('h:mm A  M/D/YY') }}
            </span>
          </td>
          <td>
            <toggle-icon
              :id="user.id"
              :model-value="getScopes(user, 'driver')"
              scope="driver"
              :scopes="user.scopes"
            />
          </td>
          <td>
            <toggle-icon
              :id="user.id"
              :model-value="getScopes(user, 'onboarding')"
              scope="onboarding"
              :scopes="user.scopes"
            />
          </td>
          <td>
            <toggle-icon
              :id="user.id"
              :model-value="getScopes(user, 'manage_users')"
              scope="manage_users"
              :scopes="user.scopes"
            />
          </td>
          <td>
            <toggle-icon
              :id="user.id"
              :model-value="getScopes(user, 'view_rate_confirmations')"
              scope="view_rate_confirmations"
              :scopes="user.scopes"
            />
          </td>

          <td>
            <popper
              placement="top"
              :hover="user.id === currentUserId ? false : true"
              :disabled="user.id === currentUserId"
            >
              <button
                :disabled="user.id === currentUserId"
                :class="
                  user.id === currentUserId
                    ? 'btn-disabled cursor-default cursor-not-allowed opacity-50'
                    : 'cursor-pointer rounded hover:bg-light-gray'
                "
                class="h-8 w-8 rounded"
                @click="deleteUser(user.id)"
              >
                <img
                  class="h-8 w-8"
                  src="@/assets/trash-icon-big.svg"
                  alt=" delete"
                />
              </button>
              <template #content>
                <div
                  class="w-auto rounded-md bg-dark-gray px-2 py-1 text-left text-2xs text-light-gray"
                >
                  Delete User
                </div>
              </template>
            </popper>
          </td>
        </tr>
      </tbody>
    </table>
    <section class="flex w-full items-center justify-center px-4 py-2">
      <pagination
        :selected-page="parseInt(pagination.currentPage)"
        :total-pages="parseInt(pagination.totalPages)"
        equivalent
        :pages-around="counterPageAround(pagination.totalPages)"
        @select-page="handlePage"
      />
    </section>
  </div>
  <invite-user-modal
    v-if="showCreateInvitation"
    :visible="showCreateInvitation"
    @invitation-sent="invitationSent"
    @close="closeModal"
  />
</template>
<script>
import Popper from 'vue3-popper';

import UserInvite from '@/mixins/userInvite';
import ToggleIcon from '@/components/ToggleIcon.vue';
// import DropdownSelect from "@/components/DropdownSelect.vue";
import WordTools from '@/mixins/wordTools';
import { toastResponse } from '@/common/handleServerResponse';
import moment from 'moment';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'UsersTable',
  components: {
    ToggleIcon,
    Popper,
    // DropdownSelect,
    Pagination,
  },
  mixins: [UserInvite, WordTools],
  setup() {
    return {
      moment,
    };
  },
  data() {
    return {
      selectOptions: ['Owner', 'Billing'],
    };
  },
  computed: {
    companyUsers() {
      return this.$store.state.users.companyUsers || [];
    },
    currentUserId() {
      return this.$store.state.users?.currentUser?.id || '';
    },
    currentUser() {
      return this.$store.state.users?.currentUser || '';
    },
    pagination() {
      return this.$store.state.users?.companyUsersPagination;
    },
  },
  methods: {
    async handlePage(newCurrentPage) {
      await this.$store.dispatch('users/getCompanyUsers', {
        page: newCurrentPage,
        perPage: 50,
        companyId: this.currentUser.company.id,
      });
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    counterPageAround(pages) {
      const NumberOfPages = parseInt(pages);
      if (NumberOfPages > 5) {
        return 2;
      } else {
        return NumberOfPages;
      }
    },
    getScopes(user, scopeSearched) {
      const sc = (sx) => sx === scopeSearched;
      return user.scopes.some(sc);
    },
    // handleDropdownSelect(e) {
    //   // TODO - Do some logic
    // },
    async deleteUser(userId) {
      let res = await this.$store.dispatch('users/deleteUser', userId);
      toastResponse(this, res, 'The user was deleted');
    },
    closeInvitationModal() {
      this.showCreateInvitation = false;
    },
    async invitationSent(res) {
      this.closeInvitationModal();
      toastResponse(this, res, 'Invite sent');
    },
  },
};
</script>
<style scoped>
.tabs-item {
  @apply block w-full text-xs font-medium uppercase leading-tight;
  @apply my-2 px-6 py-3;
  @apply hover:bg-gray-100;
}
.user-role-select {
  @apply my-0 h-full !important;
  font-size: 10px;
}
small {
  @apply text-xxs !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 10px;
  font-size: 12px;
  /* border: 1px solid rgb(237, 237, 240); */
}
table tr td {
  color: #6d7181;
  padding: 15px;
}
thead {
  background: white;
  padding: 10px 10px 10px 0;
  height: 40px;
  margin-top: 10px;
}
tbody {
  box-shadow: 0 0 0 1px rgb(237, 237, 240);
  border-radius: 10px;
  z-index: 4;
}

th {
  padding: 10px 10px 0 15px;
}
table tr:first-child td:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
table tr:first-child td:last-child {
  border-top-right-radius: 15px;
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 15px;
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 15px;
}
</style>
